module.exports = __webpack_public_path__ + "static/media/dark-modulo-configurador.52f7cd05.svg";